import { NgModule } from '@angular/core';

import { CopyToClipboardComponent } from './components/copy-to-clipboard/copy-to-clipboard.component';
import { FromNowComponent } from './components/from-now/from-now.component';
import { ImageComponent } from './components/image/image.component';
import { NotificationComponent } from './components/notification/notification.component';
import { TeamChipsComponent } from './components/team-chips/team-chips.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { DropFileDirective } from './directives/drop-file.directive';
import { EllipsisTooltipDirective } from './directives/ellipsis-tooltip.directive';
import { ScrollableDirective } from './directives/scrollable.directive';
import { TeamChipColorDirective } from './directives/team-chip-color.directive';
import { AreaPipe } from './pipes/area.pipe';
import { ExtensionPipe, FileNamePipe } from './pipes/file.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { FilterOutSpecialPipe } from './pipes/filterOutSpecial.pipe';
import { GroupPipe } from './pipes/group.pipe';
import { IsExpiredPipe } from './pipes/is-expired.pipe';
import { KeysPipe } from './pipes/keys.pipe';
import { LimitTextDisplayPipe } from './pipes/limit-text-display.pipe';
import { NonBreakingHyphenPipe } from './pipes/non-breaking-hyphen.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { PaperSizePipe } from './pipes/paper-size.pipe';
import { PerimeterPipe } from './pipes/perimeter.pipe';
import { PluralSingularPipe } from './pipes/pluralize.pipe';
import { GrossPricePipe, GrossVatPipe, PricePipe, VatPipe } from './pipes/price.pipe';
import { SeparatorPipe } from './pipes/separator.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { SubscriptionNamePipe } from './pipes/subscription-name.pipe';
import { SumPipe } from './pipes/sum.pipe';
import { TimespanPipe } from './pipes/timespan.pipe';

@NgModule({
  imports: [
    CopyToClipboardComponent,
    FromNowComponent,
    ImageComponent,
    NotificationComponent,
    TeamChipsComponent,

    AreaPipe,
    ExtensionPipe,
    FileNamePipe,
    FilterOutSpecialPipe,
    FilterPipe,
    GrossPricePipe,
    GrossVatPipe,
    GroupPipe,
    IsExpiredPipe,
    KeysPipe,
    LimitTextDisplayPipe,
    NonBreakingHyphenPipe,
    OrderByPipe,
    PaperSizePipe,
    PerimeterPipe,
    PluralSingularPipe,
    PricePipe,
    SeparatorPipe,
    SortPipe,
    SubscriptionNamePipe,
    SumPipe,
    TimespanPipe,
    VatPipe,

    AutofocusDirective,
    EllipsisTooltipDirective,
    DropFileDirective,
    ScrollableDirective,
    TeamChipColorDirective,
  ],
  exports: [
    CopyToClipboardComponent,
    FromNowComponent,
    ImageComponent,
    NotificationComponent,
    TeamChipsComponent,

    AreaPipe,
    ExtensionPipe,
    FileNamePipe,
    FilterOutSpecialPipe,
    FilterPipe,
    GrossPricePipe,
    GrossVatPipe,
    GroupPipe,
    IsExpiredPipe,
    KeysPipe,
    LimitTextDisplayPipe,
    NonBreakingHyphenPipe,
    OrderByPipe,
    PaperSizePipe,
    PerimeterPipe,
    PluralSingularPipe,
    PricePipe,
    SeparatorPipe,
    SortPipe,
    SubscriptionNamePipe,
    SumPipe,
    TimespanPipe,
    VatPipe,

    AutofocusDirective,
    EllipsisTooltipDirective,
    DropFileDirective,
    ScrollableDirective,
    TeamChipColorDirective,
  ],
})
export class SharedCommonModule {}
